import slugify from "@sindresorhus/slugify";
import {TOPIC_TYPE_PATHS, isTopicTypePathKey} from "../../../paths";
import type {ChecklistRelatedItem, CollectionMetadata} from "../types";

export const buildTopicHref = (item: ChecklistRelatedItem): string => {
    const key = Number(item.topicTypeId);
    const typePath = isTopicTypePathKey(key) ? TOPIC_TYPE_PATHS[key] : "unknown";
    return `/${typePath}/${slugify(item.name)}/${item.topicId}`;
};

// Accepts a full related item / collection response, or just the fields it
// reads, so callers that only hold an id and a name can build the same URL.
export const buildChecklistDocHref = (
    item: Pick<ChecklistRelatedItem, "name" | "topicId">,
    basePath: string,
    collection?: {
        metadata?: Pick<CollectionMetadata, "collectionId" | "name">;
    },
): string => {
    const collectionSuffix = collection?.metadata?.collectionId
        ? `/utfylling/${slugify(collection.metadata.name ?? "utfylling")}/${collection.metadata.collectionId}`
        : "";
    return `${basePath}/dokument/${slugify(item.name)}/${item.topicId}${collectionSuffix}`;
};
